<div class="gray-bg-rounded">
  <ng-container *ngIf="formArray && formArray.length > 0">
    <div *ngFor="let address of formArray.controls; let i = index" class="mb-1">
      <div [formGroup]="getFormGroup(i)" class="main p-1 bg-gry">
        <div
          class="d-flex align-items-center justify-content-between mt-1 mb-0">
          <div class="d-flex gap-5 align-items-center">
            <label
              >{{ address.value.type }}<span class="text-red">*</span>
            </label>
            <a #mydrop (click)="onViewAddresses(mydrop, address)">
              {{ address.value.name }}
            </a>
          </div>
        </div>

        <div class="d-flex gap-3 align-items-center drp-full">
          <div class="d-flex gap-3 align-items-center mt-1 col-2 mt-4">
            <label for="vendorRadio" style="display: flex; align-items: center">
              <p-radioButton
                [inputId]="'vendorRadio-' + i"
                class="me-1"
                [name]="'shipAddressType-' + i"
                value="V"
                [ngModel]="address.value.shipAddressType"
                [ngModelOptions]="{ standalone: true }"
                (onClick)="onVendorChange(i)">
              </p-radioButton>
              <span>v</span>
            </label>

            <label
              for="customerRadio"
              style="display: flex; align-items: center">
              <p-radioButton
                [inputId]="'customerRadio-' + i"
                class="me-1"
                [name]="'shipAddressType-' + i"
                value="C"
                [ngModel]="address.value.shipAddressType"
                [ngModelOptions]="{ standalone: true }"
                (onClick)="onCustomerChange(i)">
              </p-radioButton>
              <span>c</span>
            </label>

            <label for="lRadio" style="display: flex; align-items: center">
              <p-radioButton
                [inputId]="'lRadio-' + i"
                class="me-1"
                [name]="'shipAddressType-' + i"
                value="L"
                [ngModel]="address.value.shipAddressType"
                [ngModelOptions]="{ standalone: true }"
                (onClick)="onLocationChange(i)">
              </p-radioButton>
              <span>l</span>
            </label>
          </div>

          <div class="col-2 vendor-dropdown">
            <div class="form-group has-float-label">
              <label class="form-label">Country</label>
              <p-select
                (onChange)="countryChange($event.value, address.value.type)"
                formControlName="country"
                [filter]="true"
                [options]="countryRegionList"
                optionValue="countryRegionD365"
                optionLabel="countryRegionD365">
              </p-select>
            </div>
          </div>

          <div class="col-6">
            <div class="form-group has-float-label">
              <label class="form-label">
                Search
                {{
                  address.value.l
                    ? "Location"
                    : address.value.vendor
                      ? "Vendor"
                      : address.value.customer
                        ? "Client"
                        : ""
                }}
              </label>
              <p-autoComplete
                jniAutoCompleteBlocker
                #addressAutoComplete
                autocomplete="off"
                showEmptyMessage="false"
                id="conditionalInput"
                (onKeyUp)="onInputChange(i, $event, address, mydrop)"
                formControlName="formattedAddress"
                [field]="'Address.Address'"
                (completeMethod)="searchMelissaAutoComplete($event, address)"
                (onSelect)="selectedStreet($event)"
                [suggestions]="
                  toggleLocation(address) ? addressSuggestions : []
                "
                [forceSelection]="false"
                [ngClass]="{
                  'error-msg': !address.value.formattedAddress,
                }">
                <ng-template let-item pTemplate="item">
                  {{ malisaFormatter(item) }}
                </ng-template>
                <ng-template let-item pTemplate="selectedItem">
                  {{ malisaFormatter(item) }}
                </ng-template>
              </p-autoComplete>
            </div>

            <p-popover
              class="order-dropdown bordered-popover"
              *ngIf="!isNumericSearch"
              #freightAddressPopover
              aria-labelledby="dropdownBasic1"
              position="bottom"
              [appendTo]="'body'"
              [style]="{
                'margin-left': '70px',
                'margin-top': '12px',
              }"
              [appendTo]="addressAutoComplete.el.nativeElement">
              <div class="indropdowntable" style="height: 200px">
                <p-table
                  #dt
                  [value]="searchList"
                  styleClass="p-datatable-customers order-listing table-listing popuptable"
                  [rowHover]="true"
                  [rows]="10"
                  [showCurrentPageReport]="true"
                  [rowsPerPageOptions]="[10, 25, 50]"
                  [paginator]="false"
                  [filterDelay]="0"
                  [scrollable]="true"
                  stripedRows
                  [style]="{
                    border: '1px solid #e7e7e7',
                  }"
                  [size]="'small'"
                  scrollHeight="400px">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="name">Primary Address</th>
                      <th class="name">Name</th>
                      <th class="vaccount">Client Account</th>
                      <th class="vaccount">Vendor Account</th>
                      <th class="vaccount">Address</th>
                      <th class="currency">Currency</th>
                      <th class="city">City</th>
                      <th class="state">State</th>
                      <th class="country">Country</th>
                      <th class="country">Residential</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>
                        <div class="d-flex">
                          <input
                            jniAutoCompleteBlocker
                            pInputText
                            type="text"
                            name="vendorName"
                            id="vendorName"
                            style="max-width: 200px"
                            (input)="
                              dt.filter(
                                $any($event.target).value,
                                'name',
                                'contains'
                              )
                            "
                            placeholder=""
                            class="p-column-filter p-inputtext p-component" />
                        </div>
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </ng-template>
                  <ng-template
                    pTemplate="body"
                    let-vendorList
                    let-rowIndex="rowIndex">
                    <tr
                      class="p-selectable-row mousepointer"
                      (click)="
                        onVendorRowSelection(vendorList, freightAddressPopover)
                      ">
                      <td class="name mousepointer">
                        {{ vendorList.isPrimaryAddress ? "Yes" : "" }}
                      </td>
                      <td class="name mousepointer">
                        {{ vendorList.name }}
                      </td>
                      <td class="vaccount mousepointer">
                        {{ vendorList.clientAccount }}
                      </td>
                      <td class="vaccount mousepointer">
                        {{ vendorList.vendorAccountNumber }}
                      </td>
                      <td class="vaccount mousepointer">
                        {{ vendorList.addressD365 }}
                      </td>
                      <td class="sname mousepointer">
                        {{ vendorList.currency }}
                      </td>
                      <td class="city mousepointer">{{ vendorList.city }}</td>
                      <td class="state mousepointer">{{ vendorList.state }}</td>
                      <td class="country mousepointer">
                        {{ vendorList.country }}
                      </td>
                      <td class="country mousepointer">
                        {{ vendorList.isResidential ? "Yes" : "" }}
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="20">No vendor found.</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </p-popover>
          </div>

          <!--<div class="col-2 form-group has-float-label" >
          <div class="form-group has-float-label" *ngIf="address.value.IsAppartmentFieldStatus">
            <ng-select formControlName="buildingComplimentD365" class="p-0"
              (change)="onAppartmentSelection($event, i)"
              #selector>
              <ng-option> </ng-option>
              <ng-option *ngFor="let com of appartmentList" [value]="com">
                {{ com }}
              </ng-option>
            </ng-select>
            <label class="form-label">Suite Selection Box</label>
          </div>
        </div>-->

          <div class="col-1">
            <div
              class="form-check form-switch d-flex align-items-center mt-4 gap-2">
              <p-toggleSwitch
                formControlName="isResidential"
                [trueValue]="true"
                [falseValue]="false"
                id="flexSwitchCheckDefault"
                name="flexSwitchCheckDefault"
                (onChange)="handleResidential($event, address.value.type)" />
              <label class="form-check-label" for="flexSwitchCheckDefault">
                Res
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
